exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MarkdownRenderer_markdown__Dcf_q {\n  flex: 1 1;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  overflow-y: auto; }\n  .MarkdownRenderer_markdown__Dcf_q .MarkdownRenderer_content__2J4XN {\n    padding: 24px;\n    font-size: 14px; }\n    .MarkdownRenderer_markdown__Dcf_q .MarkdownRenderer_content__2J4XN a {\n      text-decoration: underline; }\n", ""]);

// Exports
exports.locals = {
	"themeDark": "#242424",
	"themeNormal": "#393939",
	"themeLight": "#505050",
	"colorFont": "#bbbbbb",
	"colorShadow": "rgba(0, 0, 0, 0.2)",
	"colorOverlay": "rgba(255, 255, 255, 0.1)",
	"colorAlert": "#f3bd58",
	"colorSelected": "#2962ff",
	"colorPatched": "#c51162",
	"colorHighlight": "#29d",
	"colorActive": "#00e676",
	"lineHeight": "32px",
	"fontSizeNormal": "12px",
	"fontSizeLarge": "14px",
	"markdown": "MarkdownRenderer_markdown__Dcf_q",
	"content": "MarkdownRenderer_content__2J4XN"
};